import { render, staticRenderFns } from "./SubCertificate.vue?vue&type=template&id=27ce308e&scoped=true&"
import script from "./SubCertificate.vue?vue&type=script&lang=js&"
export * from "./SubCertificate.vue?vue&type=script&lang=js&"
import style0 from "./SubCertificate.vue?vue&type=style&index=0&id=27ce308e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce308e",
  null
  
)

export default component.exports